/// <reference path="../../_ext/Editors/LaborGridEditor.ts" />

namespace TabAurous.Retail {

    import fld = POSSalesLaborRow.Fields;

    @Serenity.Decorators.registerClass()
    export class POSSalesLaborEditor extends _Ext.LaborGridEditor<POSSalesLaborRow> {
        protected getLocalTextPrefix() { return POSSalesLaborRow.localTextPrefix; } 

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as POSSalesItemsDialog).CalculateTotals();
                }
            });

            this.slickGrid.onRender.subscribe(() => {
                this.SetInlineLookupEditor();
            });

        }

        setMasterValues() {
            this.LaborListId = (this.parentDialog as POSSalesItemsDialog).LaborListId;
            this.LaborMarkup = (this.parentDialog as POSSalesItemsDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as POSSalesItemsDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as POSSalesItemsDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as POSSalesItemsDialog).TransDate;
            this.PartyId = (this.parentDialog as POSSalesItemsDialog).PartyId;
        }
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.LabourRate).format = num;
            Q.first(columns, x => x.field === fld.MarkUp).format = num;

            var CalcOn = Q.first(columns, x => x.field === fld.CalcOnId);
            CalcOn.referencedFields = [fld.CalcOnId];
            CalcOn.format = ctx => {
                var width = (ctx.column.width) as number - 10;
                return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="LCalcId' + ctx.row + '" title="Applicable On" />';
            };

            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        public SetInlineLookupEditor() {
            // course of all the lines present in the grid
            var Items = this.view.getItems();
            if (Items.length > 0)
                for (let Item in Items) {
                    this.InlineLookup(Item, Items);
                }
        }
         
        public override inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row) as POSSalesLaborRow;
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            var effective = this.getEffectiveValue(item, field);

            //// *** Format Number ***
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.LabourRate || field === fld.LabourAmount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.LabourRate && value > 0) {

                if (item.MarkUp > 0) {
                    item.LabourAmount = item.CalcOnId == 3 ? item.Pieces * (value + (value * (item.MarkUp / 100))) : item.Weight * (value + (value * (item.MarkUp / 100)));
                }
                else {
                    item.LabourAmount = item.CalcOnId == 3 ? item.Pieces * value : item.Weight * value;
                }
                item.OriginalLabourRate = value;
                item.OriginalLabourAmount = item.LabourAmount;
                item[field] = value;
            }

            if (field === fld.MarkUp && value > 0) {
                item.LabourAmount = item.CalcOnId == 3 ? item.Pieces * (item.LabourRate + (item.LabourRate * (value / 100))) : item.Weight * (item.LabourRate + (item.LabourRate * (value / 100)));
                item.OriginalLabourAmount = item.LabourAmount;
                item[field] = value;
            }

            if (field == fld.CalcOnId && value > 0) {
                item[field] = value;
            }

            //item.CCLabourAmount = item.LabourAmount * this.ExchangeRate;
            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as any).CalculateTotals();

        }
        //public getEffectiveValue(item, field: any): any {
        //    var id = this.id(item);
        //    var pending = this.pendingChanges[id];
        //    if (pending && pending[field] !== undefined) {
        //        return pending[field];
        //    }
        //    return item[field];
        //}

        public onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.ProcessSelectGrid;

            buttons.push({
                title: "Apply Labor Charges",
                cssClass: "add-button",
                onClick: () => {
                    this.setMasterValues();
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        Width: 400,
                        preSelectedKeys: this.view.getItems().map(k => k.ProcessId)
                    });

                    pickerDialog.onSuccess = (selectedLabor: any[]) => {
                        let filteredLabor: any[];
                        filteredLabor = selectedLabor.filter(t => { return !Q.any(this.view.getItems(), n => n.ProcessId == t.ProcessId) });
                        var self = this;
                        var LaborDetails: POSSalesLaborRow[];

                        let Item = (self.parentDialog as POSSalesItemsDialog).getItem();
                        LaborDetails = RateHelper.ApplyPurchseLabour(Item, filteredLabor, self.RateListId, self.LaborMarkup, self.TransDate);

                        for (let LaborDetail of LaborDetails) {
                            LaborDetail[this.getIdProperty()] = "`" + this.nextId++;
                            LaborDetail.OriginalLabourRate = LaborDetail.LabourRate;
                            LaborDetail.OriginalLabourAmount = LaborDetail.LabourAmount;
                            this.view.addItem(LaborDetail);
                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }
        public setData(labors: any[]) {
            this.view.setItems([]);
            for (let LaborDetail of labors) {
                LaborDetail[this.getIdProperty()] = "`" + this.nextId++;
                var x = LaborDetail;
                this.view.addItem(LaborDetail);
            }

        }
    }
}